/** Realm-Rollen aus dem dekodierten Keycloak-Token (realm_access.roles). */
export function realmRoles(token: unknown): string[] {
  if (!token || typeof token !== 'object') return [];
  const t = token as { realm_access?: { roles?: unknown } };
  const roles = t.realm_access?.roles;
  return Array.isArray(roles) ? (roles.filter((r) => typeof r === 'string') as string[]) : [];
}
